import React from 'react';

import Input from 'components/shared/Input/Input';
import Button from 'components/shared/Button/Button';

const EmailLoginForm = ({ creds, setCreds, show, setShow, onSubmit }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };

  return (
    <div>
      <Input
        placeholder="e.g. name@example.com"
        label="Email address"
        type="email"
        value={creds.email}
        onChange={(e) => {
          e.persist();
          setCreds((ps) => ({ ...ps, email: e.target.value }));
        }}
        error={show.error}
        className="!mb-4"
      />
      <Input
        placeholder="Enter password"
        label="Password"
        value={creds.pwd}
        onKeyDown={handleKeyDown}
        onChange={(e) => {
          e.persist();
          setCreds((ps) => ({ ...ps, pwd: e.target.value }));
        }}
        className="!mb-4"
        inputClassName="!min-w-full"
        type={show.pwd ? 'text' : 'password'}
        rightIcon={show.pwd ? 'eye-mono' : 'eye-slash-mono'}
        rightIconClick={() => setShow((ps) => ({ ...ps, pwd: !ps.pwd }))}
      />
      <div className="!mb-6 flex !w-full !flex-row !justify-end">
        <a
          className="text-sm text-primary-500 hover:underline"
          href="/password/request"
          target="_blank"
          rel="noopener noreferrer">
          Forgot password?
        </a>
      </div>
      <Button className="w-full" text="Log in" onClick={onSubmit} isLoading={show.loading} />
    </div>
  );
};

export default EmailLoginForm;
